import { render, staticRenderFns } from "./InfoLinkBlock.vue?vue&type=template&id=fd7f9462&scoped=true&"
import script from "./InfoLinkBlock.vue?vue&type=script&lang=js&"
export * from "./InfoLinkBlock.vue?vue&type=script&lang=js&"
import style0 from "./InfoLinkBlock.vue?vue&type=style&index=0&id=fd7f9462&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7f9462",
  null
  
)

export default component.exports